import { render, staticRenderFns } from "./SpiderOverview.vue?vue&type=template&id=f4c64a18&scoped=true&"
import script from "./SpiderOverview.vue?vue&type=script&lang=js&"
export * from "./SpiderOverview.vue?vue&type=script&lang=js&"
import style0 from "./SpiderOverview.vue?vue&type=style&index=0&id=f4c64a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c64a18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4c64a18')) {
      api.createRecord('f4c64a18', component.options)
    } else {
      api.reload('f4c64a18', component.options)
    }
    module.hot.accept("./SpiderOverview.vue?vue&type=template&id=f4c64a18&scoped=true&", function () {
      api.rerender('f4c64a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Overview/SpiderOverview.vue"
export default component.exports